import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import App from './App';
import './index.css';
import WebApp from '@twa-dev/sdk';

// Initialize Telegram WebApp — wrapped in try/catch so a missing/incompatible
// Telegram WebApp SDK on older Android WebViews doesn't prevent the React app
// from mounting (we'd otherwise get an unrecoverable blank screen).
try {
  if (WebApp && typeof WebApp.ready === 'function') {
    WebApp.ready();
  }
  if (WebApp && typeof WebApp.expand === 'function') {
    WebApp.expand();
  }
  if (WebApp && typeof WebApp.colorScheme === 'string') {
    document.body.className = WebApp.colorScheme;
  } else {
    document.body.className = 'light';
  }
} catch (err) {
  // Telegram WebApp SDK not available — log and continue (App will detect this
  // via authStore and show the BotRedirectScreen)
  console.warn('[main] Telegram WebApp init failed:', err);
  document.body.className = 'light';
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
